import { UserModel } from "./user.model";

export class CreateUserViewModel {

    user: UserModel;
    requestOrigin: string;
}
